export let PanoramaInteractions = /*#__PURE__*/function (PanoramaInteractions) {
  PanoramaInteractions["DeliverySectionUpdateSelectedDeliveryOption"] = "delivery-section-update-selected-delivery-option";
  PanoramaInteractions["DeliverySectionControllerInit"] = "delivery-section-controller-init";
  PanoramaInteractions["DeliverySectionOnDataChanged"] = "delivery-section-on-data-changed";
  PanoramaInteractions["DeliverySectionLoadDeliveryOptions"] = "delivery-section-load-delivery-options";
  return PanoramaInteractions;
}({});
export const FreeShippingCouponType = 'FreeShipping';
export const DEFAULT_LANG = 'en-US';
export const DEFAULT_CURRENCY = 'USD';
export const CHECKOUT_DELIVERY_STEP_OPTIONS_AFTER_SLOT_ID = 'checkout:delivery-step:options:after';
export let DeliveryStepState = /*#__PURE__*/function (DeliveryStepState) {
  DeliveryStepState["OPEN"] = "open";
  DeliveryStepState["SUMMARY"] = "summary";
  return DeliveryStepState;
}({});
export let SlotMethodName = /*#__PURE__*/function (SlotMethodName) {
  SlotMethodName["DisableContinueButton"] = "disableContinueButton";
  SlotMethodName["OnRefreshCheckout"] = "onRefreshCheckout";
  return SlotMethodName;
}({});
export const SUPPORTED_SLOT_METHODS = [SlotMethodName.DisableContinueButton, SlotMethodName.OnRefreshCheckout];
//# sourceMappingURL=consts.js.map